module.exports = __webpack_public_path__ + "media/images/mobile-icon2-95e65494ad935559940308f2c644fde8.png";